import React from 'react';
import _ from 'lodash';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
export const HelpTopicMappedInfoComponent = ({ dbas,orgRegistries,accounts, discount, tenantFunction, selectedFunctions, handleFormItemChange, deleteselectedFunction, openConfirmation, handleOpen, handleClose, webTemplateTypes, templateTypes, handleProductSearch, handleDeliverySearch, handleTierPriceSearch, handleCollectionPolicySearch, handleRewardPointSearch, handleDiscountSearch, handleVendorSearch, handleTopicSearch, handleModuleSearch, handleLearningPathSearch, handleCourseSearch, handleCollectionSearch, handleChannelSearch, handleCertificateSearch, handleAnnouncementSearch, handleCategorySearch, products, deliveries, collectionPolicies, tierPrices, rewards, discounts, organizationUnits, vendors, topics, modules, learningPaths, courses, collections, channels, certificates, announcements, categories, selectedFunction, selectedTemplate, handleInnerFormChange, back, handleFormSubmit }: any) => {


  return (
    <>
      <AccordionContainer
        child={
          <div>
            {_.map(selectedFunctions, (selectedFunction: any, itemIndex: any) => {

              const matchedFunction = tenantFunction.find(
                (item) => item.value === selectedFunction?.OwnerTypeId
              );

              return (
                <div key={itemIndex} className="border border-gray-800 p-4 mb-4 rounded-lg bg-gray-100">
                  <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <InputContainer
                      label="Entity Name"
                      list={tenantFunction}
                      labelField="label"
                      valueField="value"
                      optionName="Choose Entity"
                      value={selectedFunction?.OwnerTypeId}
                      onValueChange={(event: any, newValue: any) => {
                        handleFormItemChange({
                          value: event.target.value, // this will be entity.Id
                          field: 'OwnerTypeId',
                          idx: itemIndex,
                        });
                      }}
                      type="select"
                    />

                    {matchedFunction?.FunctionName === 'DBA' && (
                      <InputContainer
                        label="DBA"
                        labelField="Name"
                        list={dbas}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OwnerId',
                            idx: itemIndex,
                          });
                        }}
                        optionName="Choose DBA Name"
                        type="select"
                        valueField="Id"
                        value={selectedFunction?.OwnerId}
                      />
                    )}

                    {matchedFunction?.FunctionName === 'DBNBiz' && (
                      <InputContainer
                        label="DBNBiz"
                        labelField="AccountInfo.AccountName"
                        list={orgRegistries}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OwnerId',
                            idx: itemIndex,
                          });
                        }}
                        optionName="Choose DBNBiz Name"
                        type="select"
                        valueField="OrgRegistryId"
                        value={selectedFunction?.OwnerId}
                      />
                    )}

                    {matchedFunction?.FunctionName === 'Categories' && (
                      <InputContainer
                        label="Category Name"
                        labelField="CategoryName"
                        list={categories}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OwnerId',
                            idx: itemIndex,
                          });
                        }}
                        optionName="Choose Category Name"
                        type="select"
                        valueField="Id"
                        value={selectedFunction?.OwnerId}
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Announcements' && (
                      <InputContainer
                        label="Announcement Name"
                        labelField="Title"
                        list={announcements}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Announcement Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Certificates' && (
                      <InputContainer
                        label="Certificate Name"
                        labelField="Name"
                        list={certificates}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose certificate Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Channels' && (
                      <InputContainer
                        label="Channel Name"
                        labelField="Name"
                        list={channels}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose channel Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}

                    {matchedFunction?.FunctionName === 'Courses' && (
                      <InputContainer
                        label="Course Name"
                        labelField="Title"
                        list={courses}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Course Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'LearningPaths' && (
                      <InputContainer
                        label="LearningPaths Name"
                        labelField="Title"
                        list={learningPaths}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose learning path Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Modules' && (
                      <InputContainer
                        label="modules Name"
                        labelField="Title"
                        list={modules}

                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose modules Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Topics' && (
                      <InputContainer
                        label="Topics Name"
                        labelField="Title"
                        list={topics}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose topics Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}

                    {matchedFunction?.FunctionName === 'Accounts' && (
                      <InputContainer
                        label="Account Name"
                        labelField="Name"
                        list={accounts}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Account  Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="AccountId"
                      />
                    )}

                    {matchedFunction?.FunctionName === 'Organization Unit' && (
                      <InputContainer
                        label="organizationUnit Name"
                        labelField="OrganizationUnitInfo.Name"
                        list={organizationUnits}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Organization Unit Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="OrganizationUnitInfo.Id"
                      />
                    )}
                    {matchedFunction?.label === 'Discount' && (
                      <InputContainer
                        label="Discount Name"
                        labelField="Name"
                        list={discount}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OwnerId',
                            idx: itemIndex,
                          });
                        }}
                        optionName="Choose Discount Name"
                        type="select"
                        valueField="Id"
                        value={selectedFunction?.OwnerId}
                      />
                    )}

                    {matchedFunction?.label === 'DiscountPolicy' && (
                      <InputContainer
                        label="Discount Policy Name"
                        labelField="Name"
                        list={discounts}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OwnerId',
                            idx: itemIndex,
                          });
                        }}
                        optionName="Choose Discount Policy"
                        type="select"
                        valueField="Id"
                        value={selectedFunction?.OwnerId}
                      />
                    )}

                    {matchedFunction?.FunctionName === 'Reward Points' && (
                      <InputContainer
                        label="Rewards Name"
                        labelField="RewardPointName"
                        list={rewards}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Reward points Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Collection' && (
                      <InputContainer
                        label="CollectionPolicy Name"
                        labelField="Name"
                        list={collectionPolicies}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Collection policy Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="CollectionPolicyId"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Tier Price' && (
                      <InputContainer
                        label="TierPrice Name"
                        labelField="Name"
                        list={tierPrices}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Tier Price Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Delivery' && (
                      <InputContainer
                        label="Deliveries policy Name"
                        labelField="Name"
                        list={deliveries}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Delivery policy Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Id"
                      />
                    )}
                    {matchedFunction?.FunctionName === 'Products' && (
                      <InputContainer
                        label="Product Name"
                        labelField="Message.Name"
                        list={products}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange(
                            {
                              value: event.target.value,
                              field: 'OwnerId',
                              idx: itemIndex
                            }
                          );
                        }}
                        optionName='Choose Product Name'
                        type="select"
                        value={selectedFunction?.OwnerId}
                        valueField="Message.Id"
                      />
                    )}

                    <InputContainer
                      label="Approved"
                      name="IsApproved"
                      onValueChange={(event: any) => {
                        handleFormItemChange(
                          {
                            value: event,
                            field: 'IsApproved',
                            idx: itemIndex
                          }
                        )
                      }}
                      type="checkbox"
                      value={selectedFunction?.IsApproved}
                    />


                  </div>
                </div>
              )
            })}</div>}
        expandedPanel="Mapped Entities"
        headerTitle="Mapped Entities"
      />
    </>
  )
}
export default HelpTopicMappedInfoComponent;